import { faCheck, faCircle, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { ArtifactAcceptability, SvcResults, SvcTestResults } from '../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import ResultsGroupHeading from '../Shared/ResultsGroupHeading';

export interface QualityAcceptabilityTableProps {
    results: SvcResults;
}

interface QualityRowProps {
    title: string;
    artifact: (tr: SvcTestResults) => ArtifactAcceptability;
}

export const SvcQualityAcceptabilityTable = ({ results }: QualityAcceptabilityTableProps) => {
    const QualityAcceptability = (artifact) => {
        switch (artifact) {
            case ArtifactAcceptability.Undetermined:
                return <i aria-hidden="true" title="Undetermined">-</i>
            case ArtifactAcceptability.Acceptable:
                return <FontAwesomeIcon icon={faCheck} className="text-success" aria-hidden="true" title="Acceptable" />
            case ArtifactAcceptability.Usable:
                return <FontAwesomeIcon icon={faCircle} className="text-warning" aria-hidden="true" title="Usable" />
            case ArtifactAcceptability.NotAcceptable:
                return <FontAwesomeIcon icon={faXmark} className="text-danger" aria-hidden="true" title="Not Acceptable" />
        }
    }

    const QualityRow = ({ title, artifact }: QualityRowProps) => {
        return (
            <tr>
                <td>
                    {title}
                </td>
                {results.TestResults.map((tr) => {
                    return (
                        <td key={`Quality${tr.TestId}`}>
                            {artifact(tr) !== null && artifact(tr) !== undefined ? QualityAcceptability(artifact(tr)) : "-"}
                        </td>
                    );
                })}
                <td></td>
            </tr>
        );
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={results.TestResults.length} title="Quality Acceptability" />
            <QualityRow title="Flow Plateau" artifact={(tr) => tr.FlowPlateauQuality} />
        </>
    );
}

